// Centralized, UI-ONLY mapping from a service category to its human-readable package
// unit (Nights / Days / Sessions / Consultations / …). The backend engine keeps using
// generic "credits"/"quantity" internally — this is purely for what staff & pet parents see.
const UNIT = {
  boarding: ["Night", "Nights"],
  daycare: ["Day", "Days"],
  grooming: ["Session", "Sessions"],
  training: ["Session", "Sessions"],
  vet: ["Consultation", "Consultations"],
  spa: ["Session", "Sessions"],
  transport: ["Trip", "Trips"],
  other: ["Visit", "Visits"],
};

const PREFIX = {
  boarding: "Boarding", daycare: "Daycare", grooming: "Grooming",
  training: "Training", vet: "Vet", spa: "Spa", transport: "Transport",
};

const key = (c) => (c || "").toString().toLowerCase().trim();

// "Night" | "Nights" (plural when n !== 1). Unknown category → Visit/Visits.
export function unitLabel(category, n = 2) {
  const [one, many] = UNIT[key(category)] || UNIT.other;
  return Number(n) === 1 ? one : many;
}

// Service-qualified noun, no count: "Boarding Nights", "Vet Consultations".
export function unitNoun(category, n = 2) {
  const word = unitLabel(category, n);
  const p = PREFIX[key(category)];
  return p ? `${p} ${word}` : word;
}

// Full phrase with count: "15 Boarding Nights", "5 Vet Consultations".
export function unitPhrase(category, n) {
  return `${n} ${unitNoun(category, n)}`;
}

// Resolve a package's category from its service_ids + a {serviceId: category} map.
// Packages are single-service in Pawkt; first known category wins.
export function pkgCategory(pkg, svcCatMap = {}) {
  for (const id of pkg?.service_ids || []) {
    if (svcCatMap[id]) return svcCatMap[id];
  }
  return "";
}
